/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, {useEffect} from 'react';
import * as Modals from './modals';

const Modal = (props) => {
    useEffect(() => {
    }, []);

  	return(
		<div className="lightbox">
            {
                props.contentModal['type'] == 'address' &&
                <Modals.Address 
                    contentModal={props.contentModal}
                    changeOpenModal={props.changeOpenModal}
                    pos={props.pos}
                    changeLoader={props.changeLoader}
                    changeAlert={props.changeAlert}
                />
            }
            {
                props.contentModal['type'] == 'infoPersonal' &&
                <Modals.InfoPersonal
                    contentModal={props.contentModal}
                    changeOpenModal={props.changeOpenModal}
                    pos={props.pos}
                    changeLoader={props.changeLoader}
                    changeAlert={props.changeAlert}
                    update={props.update}
                    changeUpdate={props.changeUpdate}
                />
            }
            {
                props.contentModal['type'] == 'spaceCancel' &&
                <Modals.SpaceCancel
                    contentModal={props.contentModal}
                    changeOpenModal={props.changeOpenModal}
                    pos={props.pos}
                    changeLoader={props.changeLoader}
                    changeAlert={props.changeAlert}
                />
            }
            {
                props.contentModal['type'] == 'infoVirtualCard' &&
                <Modals.InfoVirtualCard
                    contentModal={props.contentModal}
                    changeOpenModal={props.changeOpenModal}
                    pos={props.pos}
                    changeLoader={props.changeLoader}
                    changeAlert={props.changeAlert}
                />
            }
            {
                props.contentModal['type'] == 'spaceTxTracking' &&
                <Modals.SpaceTxTracking
                    contentModal={props.contentModal}
                    changeOpenModal={props.changeOpenModal}
                    pos={props.pos}
                    changeLoader={props.changeLoader}
                    changeAlert={props.changeAlert}
                />
            }
            {
                props.contentModal['type'] == 'messageJson' &&
                <Modals.MessageJson
                    contentModal={props.contentModal}
                    changeOpenModal={props.changeOpenModal}
                    pos={props.pos}
                    changeLoader={props.changeLoader}
                    changeAlert={props.changeAlert}
                />
            }
            {
                props.contentModal['type'] == 'verifyInfo' &&
                <Modals.VerifyInfo
                    contentModal={props.contentModal}
                    changeOpenModal={props.changeOpenModal}
                    pos={props.pos}
                    changeLoader={props.changeLoader}
                    changeAlert={props.changeAlert}
                />
            }
            {
                props.contentModal['type'] == 'verifyMirai' &&
                <Modals.VerifyMirai
                    contentModal={props.contentModal}
                    changeOpenModal={props.changeOpenModal}
                    pos={props.pos}
                    changeLoader={props.changeLoader}
                    changeAlert={props.changeAlert}
                />
            }
            {
                props.contentModal['type'] == 'infoLogTutuka' &&
                <Modals.InfoLogTutuka
                    contentModal={props.contentModal}
                    changeOpenModal={props.changeOpenModal}
                    pos={props.pos}
                    changeLoader={props.changeLoader}
                    changeAlert={props.changeAlert}
                />
            }
            {
                props.contentModal['type'] == 'reportCardDetail' &&
                <Modals.ReportCardDetail
                    contentModal={props.contentModal}
                    changeOpenModal={props.changeOpenModal}
                    pos={props.pos}
                    changeLoader={props.changeLoader}
                    changeAlert={props.changeAlert}
                />
            }
            {
                props.contentModal['type'] == 'openModalReject' &&
                <Modals.OpenModalReject
                    contentModal={props.contentModal}
                    changeOpenModal={props.changeOpenModal}
                    pos={props.pos}
                    changeLoader={props.changeLoader}
                    changeAlert={props.changeAlert}
                />
            }
            {
                props.contentModal['type'] == 'customerCancel' &&
                <Modals.CustomerCancel
                    contentModal={props.contentModal}
                    changeOpenModal={props.changeOpenModal}
                    pos={props.pos}
                    changeLoader={props.changeLoader}
                    changeAlert={props.changeAlert}
                />
            }
        </div>
  	)
}

export default Modal;

